/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AssetsExpiredIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Assets Expired',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.895 34.782-11.18-20.007a.819.819 0 0 0-1.429 0L12.105 34.782A.819.819 0 0 0 12.82 36h22.36a.819.819 0 0 0 .715-1.218Zm-10.527-1.974a.456.456 0 0 1-.456.456h-1.824a.456.456 0 0 1-.456-.456v-1.825a.456.456 0 0 1 .456-.456h1.824a.456.456 0 0 1 .456.456Zm0-4.56a.456.456 0 0 1-.456.456h-1.824a.456.456 0 0 1-.456-.456v-8.21a.456.456 0 0 1 .456-.456h1.824a.456.456 0 0 1 .456.456Z"
    />
    <path
      d="M12.968 26h1.754l1.117-2H4V4h28v19.712l1.25 2.237A.986.986 0 0 0 34 25V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h9.968Z"
    />
  </svg>`;
};
